var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10L5 14L1 10",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.0622C9.83449 18.8326 11.3859 19.1412 12.9137 18.9401C14.4414 18.739 15.8601 18.0394 16.9497 16.9497C18.0394 15.8601 18.739 14.4414 18.9401 12.9137C19.1412 11.3859 18.8326 9.83449 18.0622 8.5C17.2917 7.16551 16.1024 6.12254 14.6788 5.53284C13.2551 4.94315 11.6767 4.83969 10.1883 5.23852C8.69983 5.63734 7.38459 6.51616 6.44653 7.73867C5.50846 8.96118 5 10.4591 5 12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontRefresh);
export default __webpack_public_path__ + "static/media/FontRefresh.fee7253fdc211cab49c18cf31de7fb29.svg";
export { ForwardRef as ReactComponent };